export default {"src":"/_next/static/media/target-tab-location.be77fe4d.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};